module.exports = __webpack_public_path__ + "img/1747038686_ybZ9.68027580.jpg";